import { render, staticRenderFns } from "./LoyaltyUpgrade.vue?vue&type=template&id=7565644c&"
import script from "./LoyaltyUpgrade.vue?vue&type=script&lang=js&"
export * from "./LoyaltyUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports